  const infoBtn = document.getElementById('wwPointsInfoBtn');
  const tooltip = document.getElementById('wwPointsTooltip');
  const wwPoints = document.getElementById('ww-points');

  let hideTimeout = null;

  function showTooltip() {
    tooltip.style.display = 'block';
    wwPoints.classList.add("active");
    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(hideTooltip, 10000);
  }

  function hideTooltip() {
    tooltip.style.display = 'none';
    wwPoints.classList.remove("active");
    clearTimeout(hideTimeout);
  }

  // Show on click/tap
  infoBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    showTooltip();
    const wwPointsPopup = document.querySelector('.ww-points-modal__wrapper');
    wwPointsPopup?.classList.add('show');
    document.querySelector('body').classList.add('popup-overflow-hidden');

  });
  infoBtn.addEventListener('touchstart', function(e) {
    e.stopPropagation();
    showTooltip();
  });

  // Show on mouseover, hide on mouseout
  infoBtn.addEventListener('mouseenter', function(e) {
    showTooltip();
  });
  infoBtn.addEventListener('mouseleave', function(e) {
    hideTooltip();
  });

  // Hide on outside click/tap
  document.addEventListener('mousedown', function(e) {
    if (!tooltip.contains(e.target) && e.target !== infoBtn) {
      hideTooltip();
    }
  });
  document.addEventListener('touchstart', function(e) {
    if (!tooltip.contains(e.target) && e.target !== infoBtn) {
      hideTooltip();
    }
  });